module.exports = __webpack_public_path__ + "img/dinner.143ab51c.svg";